import { atom } from 'jotai';

export const syncTooltipAtom = atom(false);
export const selectedWidgetsAtom = atom({ widgets: {}, totalCount: 0 });
